import type { Task } from '../api/tasks.js';
import type { Project } from '../api/projects.js';

/**
 * Today et Upcoming n'affichent pas les tâches d'un projet marqué `hideFromAgenda` — celles
 * qu'un autre écran montre déjà (le Kindle de la maison) — **sauf en retard** : une tâche
 * d'hier ou avant n'a pas été faite, le mur ne suffit plus, elle revient dans l'app.
 *
 * Même règle dans le widget Android Aujourd'hui (`android/.../etat/Fusion.kt`).
 */
export function agendaTasks(tasks: Task[], projects: Project[], today: string): Task[] {
  const hidden = new Set(projects.filter((p) => p.hideFromAgenda).map((p) => p.projectId));
  if (hidden.size === 0) return tasks;
  return tasks.filter(
    (t) => !hidden.has(t.projectId) || (t.dueDate !== null && t.dueDate < today)
  );
}
